import { useEmbed } from '@components/utils/contexts/EmbedContext';
import { PostMessageCTA } from '@components/utils/events/PostMessageCTA';
import { STORY } from '@constants';
import styled from '@emotion/styled';
import {
    OutboundLinkContext,
    OutboundLinkDestinationCategory,
    OutboundLinkShape,
} from '@enums';
import { AdditionalProductFragment } from '@graphql/generated/graphql';
import { Button, lineClamp } from '@lib/uikit';
import { AdditionalProductActionType, hasShopifyAddToCartAction } from '@types';
import { useTranslation } from 'next-i18next';
import { MouseEventHandler, useState } from 'react';

enum ActionStatus {
    STAND_BY = 'STAND_BY',
    DOING = 'DOING',
    FINISHED = 'FINISHED',
}

type PropsType = {
    additionalProduct: AdditionalProductFragment;
};

const AdditionalProductBannerActionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const Text = styled.span`
    color: inherit;
    padding: 0;
    font: ${({ theme }) => theme.fonts.caption};
    line-height: 1.5;
    ${lineClamp(2)};
`;

export const AdditionalProductBannerActions = ({
    additionalProduct,
}: PropsType) => {
    const { t } = useTranslation(STORY);
    const { isStoryBundle } = useEmbed();
    const [actionStatus, setActionStatus] = useState<ActionStatus>(
        ActionStatus.STAND_BY
    );

    if (!additionalProduct.Url) return null;

    const handleClick: MouseEventHandler<HTMLDivElement> = () => {
        setActionStatus(ActionStatus.FINISHED);
    };

    if (isStoryBundle && hasShopifyAddToCartAction(additionalProduct.Actions)) {
        return (
            <AdditionalProductBannerActionsContainer>
                <PostMessageCTA
                    destination={additionalProduct.Url}
                    destination_name={additionalProduct.Name}
                    destination_category={
                        OutboundLinkDestinationCategory.AdditionalProduct
                    }
                    context={OutboundLinkContext.StoryPage}
                    shape={OutboundLinkShape.Banner}
                    action={AdditionalProductActionType.SHOPIFY_ADD_TO_CART}
                    actionPayload={
                        additionalProduct.Actions[
                            AdditionalProductActionType.SHOPIFY_ADD_TO_CART
                        ]
                    }
                    onClick={handleClick}
                    preventDefault
                    stopPropagation
                >
                    <Button
                        leftIcon={
                            actionStatus === ActionStatus.FINISHED
                                ? 'done'
                                : undefined
                        }
                        buttonSize='small'
                        disabled={actionStatus === ActionStatus.FINISHED}
                    >
                        {actionStatus === ActionStatus.STAND_BY && (
                            <Text>
                                {t('additional_product.actions.add_to_cart')}
                            </Text>
                        )}
                    </Button>
                </PostMessageCTA>
            </AdditionalProductBannerActionsContainer>
        );
    }
    return null;
};
